import BaseWidget, { escapeHtml } from './baseWidget.js';
import stammdatenService from '../../services/stammdatenService.js';
import schichtService from '../../services/schichtService.js';
import dayjs from '../../../../../shared/services/dayjs.js';
import { getAktuellerZeitraum } from '../../util.js';

/**
 * Listet alle offenen Urlaubsanträge der Mitarbeiter im aktuell gewählten Betrieb auf.
 * Daten kommen aus der Mitarbeiterliste (Beschaeftigung[0].Urlaubsantraege wird vom
 * Backend bereits in das Listenobjekt projiziert).
 */
export default class OpenVacationsWidget extends BaseWidget {
    async onRender() {
        this.setLoading();
        const zeitraum = getAktuellerZeitraum();
        const malist = await stammdatenService.holeMitarbeiterListe(
            stammdatenService.aktuelleBetriebsstaette,
            zeitraum,
        );

        const heute = dayjs();
        const offene = [];
        malist.forEach((ma) => {
            (ma.Urlaubsantraege || []).forEach((ua) => {
                if (ua.UrlaubStatus !== 'offen') return;
                if (heute.isAfter(ua.UrlaubBis, 'day')) return;
                offene.push({ ma, ua });
            });
        });

        if (offene.length === 0) {
            this.setEmpty('Keine offenen Urlaubsanträge.');
            return;
        }

        offene.sort((a, b) => new Date(a.ua.UrlaubVon) - new Date(b.ua.UrlaubVon));

        this.bodyEl.innerHTML = '';
        offene.forEach(({ ma, ua }) => {
            const item = document.createElement('div');
            item.className = 'widget-vacation-item';
            item.innerHTML = `
                <div>
                    <div class="vac-ma">${escapeHtml(`${ma.Nachname}, ${ma.Vorname}`)}</div>
                    <div class="vac-dates">${dayjs(ua.UrlaubVon).format('DD.MM.YYYY')} – ${dayjs(ua.UrlaubBis).format('DD.MM.YYYY')}</div>
                </div>
                <div class="vac-actions">
                    <i class="bi bi-check-circle-fill vac-genehmigen" title="Urlaubsantrag genehmigen"></i>
                    <i class="bi bi-x-circle-fill vac-ablehnen" title="Urlaubsantrag ablehnen"></i>
                </div>
            `;
            item.querySelector('.vac-genehmigen').addEventListener('click', async () => {
                const result = await schichtService.erstelleUrlaubAusAntrag(ma._id, ua._id, 'genehmigt');
                if (result) this.animateRemove(item, 'vac-confirm-genehmigt');
            });
            item.querySelector('.vac-ablehnen').addEventListener('click', async () => {
                const result = await stammdatenService.ablehnenUrlaubsantrag(ma._id, ua._id);
                if (result) this.animateRemove(item, 'vac-confirm-abgelehnt');
            });
            this.bodyEl.appendChild(item);
        });
    }

    animateRemove(item, animationClass) {
        item.style.maxHeight = `${item.offsetHeight}px`;
        item.style.overflow = 'hidden';
        item.classList.add(animationClass);
        item.addEventListener('animationend', () => {
            item.remove();
            if (!this.bodyEl.querySelector('.widget-vacation-item')) {
                this.setEmpty('Keine offenen Urlaubsanträge.');
            }
        }, { once: true });
    }
}
